import sharedStyles from "../styles/styles";

export function getMenuList(menuList, handleOnClick) {
  return {
    menuListItems: menuList
      ? menuList.map((menuListItem) => ({
          key: menuListItem.key,
          name: menuListItem.value,
          onClick: () => handleOnClick(menuListItem),
          props: sharedStyles?.menuItemStyle ? { sx: sharedStyles?.menuItemStyle } : {},
        }))
      : [],
    props: {
      PaperProps: { sx: sharedStyles.menuListStyle },
      anchorOrigin: { vertical: "bottom", horizontal: "center" },
      transformOrigin: { vertical: "top", horizontal: "center" },
    },
  };
}
